import React, { useEffect, useState } from "react";
// import "./App.scss";
import Main from "./Main";
import axios from "axios";
import { HashRouter as Router } from "react-router-dom";
import { AuthProvider } from "./context/Auth";
import { ConfigProvider } from "./context/Config";
import { CurrentPageProvider } from "./context/CurrentPage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { ThemeProvider } from "./context/Theme";
import { FeatureSettingProvider } from "./context/FeatureSettings";
import { AuthProvider as AuthContextProvider } from "./context/AuthContext";
import Loader from "./assets/loaders/PreLoader";
import { PermissionProvider } from "./context/PermissionContext";
import { NewAuthProvider } from "./context/NewAuthContext";
import { I18nextProvider } from "react-i18next";
import i18n from "./utils/i18n";
import { RTLProvider } from "./context/RTLContext";
import useRTLContext from "./hooks/useRTLContext";
import { CurrentUserProvider } from "./context/CurrentUserContext";
import { SessionProvider } from "./context/SessionContext";

function App() {
  const [configFetched, setConfigFetched] = useState(false);
  const [config, setConifg] = useState();
  const { isRTL, direction } = useRTLContext();

  useEffect(() => {
    axios
      .get("config/appConfig.json")
      .then(function (res) {
        var appconfig = res.data;
        setConifg(appconfig);
        setConfigFetched(true);
      })
      .catch(function (res) {
        console.log(res);
        console.log("An error occurred config in appjs");
      });
  }, []);

  useEffect(() => {
    console.log("app.js rtl block:");
    const currentLanguage = i18n.language;
    document.documentElement.lang = currentLanguage;
    document.documentElement.dir = currentLanguage === "ar" ? "rtl" : "ltr";
  }, [i18n.language]);

  return (
    config &&
    configFetched && (
      <I18nextProvider i18n={i18n}>
        <ThemeProvider>
          <ConfigProvider>
            <RTLProvider>
              <PermissionProvider>
                <NewAuthProvider>
                  <AuthProvider>
                    <AuthContextProvider>
                      <SessionProvider>
                        <CurrentUserProvider>
                          <CurrentPageProvider>
                            <Router>
                              <DndProvider backend={HTML5Backend}>
                                <FeatureSettingProvider>
                                  <Main />
                                  <Loader />
                                </FeatureSettingProvider>
                              </DndProvider>
                              <ToastContainer
                                position="top-right"
                                autoClose={2500}
                                hideProgressBar={false}
                                newestOnTop={false}
                                closeOnClick
                                rtl={false}
                                pauseOnFocusLoss
                                draggable
                                pauseOnHover
                                theme="light"
                              />
                            </Router>
                          </CurrentPageProvider>
                        </CurrentUserProvider>
                      </SessionProvider>
                    </AuthContextProvider>
                  </AuthProvider>
                </NewAuthProvider>
              </PermissionProvider>
            </RTLProvider>
          </ConfigProvider>
        </ThemeProvider>
      </I18nextProvider>
    )
  );
}

export default App;
